import {
  Action, Button, CloseBtn, PopupMessage, MessageText
} from '../styles/styles.js';
import { CloseIcon } from "./icons";

const DialogBox = ({text, closeBox}) => {
  return (
    <PopupMessage>
      <CloseBtn className="small" onClick={closeBox}><CloseIcon/></CloseBtn>
      <MessageText dangerouslySetInnerHTML={{ __html: text }}></MessageText>
      <Action className="center">
        <Button className="inline" onClick={closeBox}>Ok</Button>
      </Action>
    </PopupMessage>
  );
}

export default DialogBox;
